var render = function (_h,_vm) {var _c=_vm._c;return _c('div',_vm._b({staticClass:"my-5",class:[_vm.data.class, _vm.data.staticClass, ("container-" + (_vm.props.width))]},'div',_vm.data.attrs,false),[(_vm.slots().header)?_c('header',{staticClass:"text-center mb-5"},[_vm._t("header")],2):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }